// @ts-nocheck

import React from 'react';

import styles from './barcode.module.scss';
import { getBarcodeBorderColor, getTicketBackgroundColor } from '@/v2/helpers/ticketColors/ticketColorsHelper.ts';
import RotatingOrStaticBarcode from './rotatingOrStaticBarcode.tsx';
import { ProductModel } from '@/v2/models/productModel.ts';
import VoidedBarcode from '@/v2/wallet/items/barcode/voidedBarcode.tsx';

type Props = {
  product: ProductModel;
};

const ProductBarcode = ({ product }: Props) => {
  const ticketBarcodeClassNames = `${styles.ticketBarcode} ${styles.ticketBarcodeBarcode}`;

  const outerBarcodeBackgroundColor = getTicketBackgroundColor(product);
  const barcodeBorderColor = getBarcodeBorderColor(product);

  function renderBarcodeComponent() {
    if (product.voidedAt != null) {
      return <VoidedBarcode/>;
    }
    return <RotatingOrStaticBarcode itemTicket={product}/>;
  }

  return (
    <section className={ticketBarcodeClassNames} style={{ backgroundColor: outerBarcodeBackgroundColor, borderColor: barcodeBorderColor }}>
      {renderBarcodeComponent()}
    </section>
  );
};

export default ProductBarcode;
